// prop-types is a library for typechecking of props
import React, {useState} from "react";
// Material Dashboard React components
import MDBox from "components/MDBox";
import PropTypes from "prop-types";
import {checkIfOutlier} from "utils/helper";
import colors from "../../../assets/theme/base/colors";

function DataTableBodyCell({
                             noBorder,
                             align,
                             children,
                             percentiles,
                             cell,
                             index,
                             editableRowIndex,
                           }) {
  const [highlight, setHighlight] = useState(false);
  const [value, setValue] = React.useState(cell.value);

  // console.log(cell.row, percentiles, "FOUND")
  if (!highlight && cell.row && cell.row.values && percentiles) {
    if (checkIfOutlier(cell.row.values, percentiles)) {
      setHighlight(true);
    }
  }

  const isStaticValue = index !== editableRowIndex || cell.column.Header.includes("Actions");

  return (
    <MDBox
      component="td"
      textAlign={align}
      py={isStaticValue ? 1.5 : 0.5}
      px={isStaticValue ? 3 : 1}
      sx={({palette: {light}, typography: {size}, borders: {borderWidth}}) => ({
        fontSize: size.sm,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
      })}
    >
      {" "}
      {isStaticValue ? (
        <MDBox
          display="inline-block"
          width="max-content"
          color={highlight ? colors.error.main : "text"}
          sx={{verticalAlign: "middle"}}
        >
          {children}
        </MDBox>
      ) : (
        <input type="text" value={value} onChange={(e) => setValue(e.target.value)}/>
      )}
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  percentiles: false,
  cell: false,
  index: 0,
  editableRowIndex: false,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number,
  editableRowIndex: PropTypes.bool,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  percentiles: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  cell: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export default DataTableBodyCell;
